module.exports = __webpack_public_path__ + "media/media/logos/usaa-logo-babffe9e630b9cd8cb72aedfc8fd00fa.png";